/* HeyASD Library: small progressive enhancements. No dependencies.
   1. Turns article FAQs (.hasd-faq-item, .hasd-article-faq__item) into accordions.
      The answers stay in the HTML, so search engines and AI answer engines still read them.
   2. Adds "Copy quote" and "Share quote" to lived-experience quotes.
   3. Same accordion for the resources page FAQ and the FAQ page. */
(function () {
  'use strict';

  function plus() {
    var s = document.createElement('span');
    s.className = 'hl-pm';
    s.setAttribute('aria-hidden', 'true');
    s.textContent = '+';
    return s;
  }

  function enhanceFaq(item, index) {
    if (item.dataset.hlAcc) return;
    var q = item.querySelector('h3, .hasd-article-faq__question');
    if (!q) return;
    var answerNodes = [];
    var n = q.nextElementSibling;
    while (n) { answerNodes.push(n); n = n.nextElementSibling; }
    if (!answerNodes.length) return;

    var id = 'hl-acc-' + index;
    var wrap = document.createElement('div');
    wrap.className = 'hl-acc-a';
    wrap.id = id;
    answerNodes.forEach(function (a) { wrap.appendChild(a); });

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hl-acc-q';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);
    var label = document.createElement('span');
    label.textContent = q.textContent.trim();
    btn.appendChild(label);
    btn.appendChild(plus());

    q.textContent = '';
    q.appendChild(btn);
    item.appendChild(wrap);
    wrap.hidden = true;
    item.dataset.hlAcc = '1';

    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      wrap.hidden = open;
    });
  }

  function enhanceQuote(quote) {
    if (quote.dataset.hlQuote) return;
    var textEl = quote.querySelector('.hasd-article-quote__text');
    if (!textEl) return;
    var text = textEl.textContent.trim();
    var tools = document.createElement('div');
    tools.className = 'hl-quote-tools';

    var copy = document.createElement('button');
    copy.type = 'button';
    copy.textContent = 'Copy quote';
    copy.addEventListener('click', function () {
      var payload = text + ' (via HeyASD, ' + location.href.split('#')[0] + ')';
      var done = function () { copy.textContent = 'Quote copied'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(payload).then(done, done);
      } else { done(); }
    });
    tools.appendChild(copy);

    if (navigator.share) {
      var share = document.createElement('button');
      share.type = 'button';
      share.textContent = 'Share quote';
      share.addEventListener('click', function () {
        navigator.share({ text: text, url: location.href.split('#')[0] }).catch(function () {});
      });
      tools.appendChild(share);
    }
    quote.appendChild(tools);
    quote.dataset.hlQuote = '1';
  }


  /* Shared accordion for FAQ lists that arrive as plain text (resources page, FAQ page).
     Answers stay in the HTML. */
  var accN = 0;
  function makeAccordion(item, q, answers) {
    if (!q || !answers.length || item.dataset.hlAcc) return;
    var id = 'hl-faq-' + (accN++);
    var wrap = document.createElement('div');
    wrap.className = 'hl-acc-a';
    wrap.id = id;
    answers.forEach(function (a) { wrap.appendChild(a); });
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hl-acc-q';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);
    var label = document.createElement('span');
    label.textContent = q.textContent.trim();
    btn.appendChild(label);
    btn.appendChild(plus());
    q.textContent = '';
    q.removeAttribute('style');
    q.appendChild(btn);
    item.appendChild(wrap);
    item.classList.add('hl-acc-item');
    item.removeAttribute('style');
    wrap.hidden = true;
    item.dataset.hlAcc = '1';
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      wrap.hidden = open;
    });
  }

  function enhanceResourcesFaq() {
    var root = document.getElementById('hasd-rp');
    if (!root) return;
    root.querySelectorAll('h2.rp-h2').forEach(function (h) {
      if (!/frequently asked/i.test(h.textContent)) return;
      var list = h.nextElementSibling;
      if (!list) return;
      list.classList.add('hl-acc-list');
      list.removeAttribute('style');
      Array.prototype.slice.call(list.children).forEach(function (item) {
        var ps = item.querySelectorAll(':scope > p');
        if (ps.length < 2) return;
        makeAccordion(item, ps[0], Array.prototype.slice.call(ps, 1));
      });
    });
  }

  function enhanceFaqPage() {
    if (!/^\/pages\/faqs?\/?$/.test(location.pathname)) return;
    document.querySelectorAll('main rte-formatter, main .rte').forEach(function (rte) {
      Array.prototype.slice.call(rte.querySelectorAll(':scope > h3')).forEach(function (h3) {
        var answers = [];
        var n = h3.nextElementSibling;
        while (n && !/^H[1-3]$/.test(n.tagName)) { answers.push(n); n = n.nextElementSibling; }
        var item = document.createElement('div');
        rte.insertBefore(item, h3);
        item.appendChild(h3);
        makeAccordion(item, h3, answers);
      });
    });
  }


  /* Share buttons: drop emoji and symbol icons, keep the words */
  function cleanShareLabels() {
    var re = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{1D400}-\u{1D7FF}\u{FE0F}]/gu;
    document.querySelectorAll('.asd-share-btn, .ha-share-btn, .ha-social-btn, .ha-sidebar-copy').forEach(function (el) {
      Array.prototype.slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeType === 3) n.textContent = n.textContent.replace(re, '').replace(/^\s+/, '');
      });
    });
  }

  /* Em dashes in template copy (about page, articles index, blanket founder quote).
     Display fix until the templates themselves are edited; specific rewrites first, then a comma fallback. */
  var DASH_FIXES = [["This is that place \u2014", "This is that place:"], ["The book \u2014 The Unmasking", "The book: The Unmasking"], ["as a compliment \u2014", "as a compliment,"], ["diagnosis late \u2014", "diagnosis late,"], ["already lived \u2014", "already lived,"], ["people like me \u2014", "people like me,"], ["About burnout \u2014 how", "About burnout, and how"], ["were scattered \u2014", "were scattered:"], ["inside \u2014 the masking", "inside: the masking"], ["Autistic burnout \u2014 the real kind, not the trendy kind.", "Autistic burnout (the real kind, not the trendy kind)."], ["goes further \u2014 into", "goes further, into"], ["too much \u2014 what", "too much: what"], ["genuine thought \u2014", "genuine thought,"], ["market opportunity \u2014", "market opportunity,"], ["thoughtful gifts \u2014", "thoughtful gifts,"], ["lived experience \u2014", "lived experience,"], ["built around that experience \u2014", "built around that experience:"], ["non-autistic \u2014 what it costs", "non-autistic: what it costs"], ["as an adult \u2014 and what to do", "as an adult, and what to do"], ["responds differently \u2014 and how", "responds differently, and how"], ["friendship \u2014 what the autistic", "friendship: what the autistic"], ["no clinical framing \u2014 just recognition.", "no clinical framing. Just recognition."], ["worthy, and calm \u2014", "worthy, and calm,"], ["gave up to belong \u2014 it lands", "gave up to belong. It lands"], ["sensory seeking \u2014 craving", "sensory seeking: craving"], ["outsider mind \u2014 Westeros", "outsider mind. Westeros"], ["about immigration \u2014 what the rules", "about immigration: what the rules"], ["genuinely work \u2014 why they work", "genuinely work: why they work"], ["The answer to a draining job isn't pushing through harder \u2014 it's work built around", "The answer to a draining job is work built around"], ["clarity and connection \u2014 on your terms", "clarity and connection, on your terms"], ["for autistic adults \u2014 flexible", "for autistic adults: flexible"], ["from the inside \u2014 for adults", "from the inside, for adults"], ["with a price \u2014 at work", "with a price, at work"], ["performance evolves \u2014 from childhood", "performance evolves, from childhood"], ["Not laziness, not a failure to self-advocate \u2014 a learned response", "It's a learned response"], ["then grief \u2014 for the years", "then grief for the years"], ["from depression \u2014 and why", "from depression, and why"], ["they've worn \u2014 what it cost", "they've worn: what it cost"], ["\u2014 Daniel, Autistic Founder", "Daniel, Autistic Founder"]];
  function fixDashes() {
    var p = location.pathname, roots = [];
    if (/^\/pages\/about\/?$/.test(p) || /^\/blogs\/autism\/?$/.test(p) || /^\/blogs\/autism\/tagged\//.test(p)) roots = [document.querySelector('main') || document.body];
    else if (/^\/products\//.test(p)) roots = Array.prototype.slice.call(document.querySelectorAll('[id$="__section_xcRVGL"]'));
    var res = DASH_FIXES.map(function (f) {
      var src = f[0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/ /g, '\\s+');
      return [new RegExp(src, 'g'), f[1]];
    });
    roots.forEach(function (root) {
      if (!root) return;
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
      while ((n = w.nextNode())) { if (n.nodeValue.indexOf('\u2014') > -1 && !/^(STYLE|SCRIPT)$/.test(n.parentNode.nodeName)) list.push(n); }
      list.forEach(function (t) {
        var v = t.nodeValue;
        res.forEach(function (r) { v = v.replace(r[0], r[1]); });
        v = v.replace(/^\s+\u2014\s+/, ', ').replace(/\s+\u2014\s+/g, ', ');
        t.nodeValue = v;
      });
    });
  }

  function run() {
    var i = 0;
    document.querySelectorAll('.ha-body .hasd-faq-item, .ha-body .hasd-article-faq__item').forEach(function (el) { enhanceFaq(el, i++); });
    document.querySelectorAll('.ha-body .hasd-article-quote').forEach(enhanceQuote);
    enhanceResourcesFaq();
    enhanceFaqPage();
    cleanShareLabels();
    fixDashes();
    /* Sidebar still says the first edition's page count; correct it until the section is edited. */
    document.querySelectorAll('.ha-sidebar-book__proof').forEach(function (el) {
      el.textContent = el.textContent.replace('222 pages', '202-page ebook');
    });
    document.querySelectorAll('.ha-sidebar-book__sub').forEach(function (el) {
      el.textContent = el.textContent.replace(/\s*\u2014\s*/g, ', ');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
